import { render, staticRenderFns } from "./FormDg.vue?vue&type=template&id=28e6438a&scoped=true"
import script from "./FormDg.vue?vue&type=script&lang=js"
export * from "./FormDg.vue?vue&type=script&lang=js"
import style0 from "./FormDg.vue?vue&type=style&index=0&id=28e6438a&prod&lang=less&scoped=true"
import style1 from "./FormDg.vue?vue&type=style&index=1&id=28e6438a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e6438a",
  null
  
)

export default component.exports